import { render, staticRenderFns } from "./LuckySheetDataView.vue?vue&type=template&id=0c37f7d5&scoped=true"
import script from "./LuckySheetDataView.vue?vue&type=script&lang=js"
export * from "./LuckySheetDataView.vue?vue&type=script&lang=js"
import style0 from "./LuckySheetDataView.vue?vue&type=style&index=0&id=0c37f7d5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c37f7d5",
  null
  
)

export default component.exports